"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GTM_START_EVENT = exports.GTM_START = void 0;
const GTM_START = exports.GTM_START = 'gtm.start';
const GTM_START_EVENT = exports.GTM_START_EVENT = 'gtm.js';